import messages from './messages.mjs';

const getEmailSuggestionFormatter = (intl) => (email) => intl.formatMessage(
  messages.emailSuggestion,
  { email },
);

export default getEmailSuggestionFormatter;
